export const environment = {
  production: true,

  apiUrl:
    'https://meu-cardapio-hml-llduj.ondigitalocean.app/api',

  appUrl: '',
    platformDomain:
    'hml.meumenuapp.com.br',

  mercadoPagoPublicKey:
    'APP_USR-3725e8e7-eed5-43b7-9285-488d656a2f5e'
};